import { Injectable } from '@angular/core';
import { TrackingService } from '@shared/modules/tracking/tracking.service';
import { COMMIT, BUILD_TIMESTAMP } from '@shared/build-info';

@Injectable()
export class TrackingServiceWeb extends TrackingService {
  appVersion = `_${BUILD_TIMESTAMP?.split('.')[0]?.replace('T', '_')}_${COMMIT}_`;
}
